export const PROJECT_DELAY_TYPE = {
    NO_DELAY: 1 << 0,
    _24_HOUR: 1 << 1
}

export const FORM_FIELD_NAMES = {
    DELAY_SETTINGS: "delaySettings"
}